module.exports = __webpack_public_path__ + "static/media/icon_fold_on.5ca1b6d9.svg";